import api from "../../services/api";

const quickMessagesCache = new Map();
const CACHE_TTL_MS = 60000; // 60s cache

const useQuickMessages = () => {

    const save = async (data) => {
        quickMessagesCache.clear();
        const { data: responseData } = await api.request({
            url: '/quick-messages',
            method: 'POST',
            data
        });
        return responseData;
    }

    const update = async (data) => {
        quickMessagesCache.clear();
        const { data: responseData } = await api.request({
            url: `/quick-messages/${data.id}`,
            method: 'PUT',
            data
        });
        return responseData;
    }

    const deleteRecord = async (id) => {
        quickMessagesCache.clear();
        const { data } = await api.request({
            url: `/quick-messages/${id}`,
            method: 'DELETE'
        });
        return data;
    }

    const list = async (params) => {
        const cacheKey = JSON.stringify(params || {});
        const cached = quickMessagesCache.get(cacheKey);
        if (cached && (Date.now() - cached.timestamp < CACHE_TTL_MS)) {
            return cached.data;
        }

        const { data } = await api.request({
            url: '/quick-messages/list',
            method: 'GET',
            params
        });

        quickMessagesCache.set(cacheKey, {
            data,
            timestamp: Date.now()
        });

        return data;
    }

    return {
        save,
        update,
        deleteRecord,
        list
    }
}

export default useQuickMessages;
